import * as z from "zod";

const BrandBreakdownItem_ = z.object({
  teamId: z.string().describe("MongoDB team ID as string"),
  teamName: z.string(),
  aeoEnabled: z
    .boolean()
    .describe("Whether AEO toggle is enabled for this brand"),
  hasBig: z.boolean().describe("Whether brand has Brand Identity Guide"),
  activePrompts: z.number().describe("Count of active prompts (not deleted)"),
  hasSubscription: z.boolean().describe("Whether brand has AEO subscription"),
  notSubscribed: z
    .boolean()
    .describe("Whether brand has AEO enabled but not subscribed"),
  mrr: z.number().describe("Monthly recurring revenue in cents"),
  startDate: z
    .string()
    .nullable()
    .describe(
      "Subscription start date in ISO format, or null if no subscription",
    ),
});
export const BrandBreakdownItem: z.ZodType<BrandBreakdownItem> =
  BrandBreakdownItem_;
export interface BrandBreakdownItem
  extends z.infer<typeof BrandBreakdownItem_> {}

export const getAeoDashboardAnalytics = {
  name: "getAeoDashboardAnalytics" as const,
  input: z.object({
    filters: z
      .object({
        aeoEnabled: z.boolean().optional().describe("Filter by AEO enabled"),
        hasBig: z
          .boolean()
          .optional()
          .describe("Filter by has Brand Identity Guide"),
        subscribed: z
          .boolean()
          .optional()
          .describe("Filter by has subscription"),
        notSubscribed: z
          .boolean()
          .optional()
          .describe("Filter by AEO enabled but not subscribed"),
        minMrr: z.number().optional().describe("Minimum MRR filter in cents"),
        maxMrr: z.number().optional().describe("Maximum MRR filter in cents"),
      })
      .optional()
      .describe("Optional filters for the dashboard"),
  }),
  output: z.object({
    globalMetrics: z.object({
      aeoEnabledCount: z
        .number()
        .describe("Total brands with AEO toggle enabled"),
      bigCount: z.number().describe("Total brands with Brand Identity Guide"),
      totalAeoTeamsCount: z
        .number()
        .describe(
          "Total AEO teams (AEO enabled + teams with Fake Address marker)",
        ),
      subscriptionCount: z.number().describe("Total brands on subscription"),
      totalMrr: z
        .number()
        .describe("Sum of monthly subscription amounts in cents"),
      notSubscribedCount: z
        .number()
        .describe("Brands with AEO enabled but not subscribed"),
      xsellNeededCount: z
        .number()
        .describe("Brands who are currently only on AEO (no other products)"),
    }),
    brandBreakdown: z
      .array(BrandBreakdownItem)
      .describe("Per-brand breakdown of all Total AEO Teams"),
  }),
};
